var path = 'alarm/alarms.tpl.html';
var html = " <div class=\"tk-absolute-fill tk-alarms-content\" layout=column> <tk-events flex layout=column all-alarms=true></tk-events> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/alarm/alarms.tpl.html
// module id = 1878
// module chunks = 1